import { Card, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const ProyeccionesChart = ({ data, compact = false }) => (
  <Card
    sx={{
      p: { xs: 1.25, sm: 2 },
      borderRadius: 2.5,
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "0 6px 16px rgba(15,23,42,0.08)",
      minWidth: 0,
    }}
  >
    <Typography variant={compact ? "subtitle1" : "h6"} fontWeight={800}>
      {compact ? "Proyecciones" : "Proyecciones de Ventas (por fecha de cobro)"}
    </Typography>
    <ResponsiveContainer width="100%" height={compact ? 220 : 350}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="fecha" hide />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="proyecciones"
          stroke="#9c27b0"
          strokeWidth={2}
          dot={false}
          name="Proyección Ventas"
        />
        <Line
          type="monotone"
          dataKey="proyeccionesCompra"
          stroke="#ff5722"
          strokeWidth={2}
          dot={false}
          name="Proyección Compras"
        />
      </LineChart>
    </ResponsiveContainer>
  </Card>
);

export default ProyeccionesChart;
